export default "__VITE_ASSET__jNAAt2Kl__"